module.exports = "<div class=\"row\">\r\n  \r\n  \r\n</div>\r\n"